'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreXTransacationStatus = exports.CoreXOperationType = void 0;
var CoreXOperationType;
(function (CoreXOperationType) {
    CoreXOperationType["CREDIT"] = "Credit";
    CoreXOperationType["DEBIT"] = "Debit";
})(CoreXOperationType = exports.CoreXOperationType || (exports.CoreXOperationType = {}));
var CoreXTransacationStatus;
(function (CoreXTransacationStatus) {
    CoreXTransacationStatus["NEW"] = "New";
    CoreXTransacationStatus["PENDING_VALIDATION"] = "PendingValidation";
    CoreXTransacationStatus["PENDING_AUTHORIZATION"] = "PendingAuthorization";
    CoreXTransacationStatus["PENDING_REVERSAL"] = "PendingReversal";
    CoreXTransacationStatus["AUTHORIZED"] = "Authorized";
    CoreXTransacationStatus["SUBMITTED"] = "Submitted";
    CoreXTransacationStatus["COMPLETED"] = "Completed";
    CoreXTransacationStatus["REJECTED"] = "Rejected";
    CoreXTransacationStatus["CANCELED"] = "Canceled";
    CoreXTransacationStatus["DECLINED"] = "Declined";
    CoreXTransacationStatus["REVERSED"] = "Reversed";
    CoreXTransacationStatus["FAILED"] = "Failed";
})(CoreXTransacationStatus = exports.CoreXTransacationStatus || (exports.CoreXTransacationStatus = {}));
